import React from 'react';
import './LegalPage.css';

const TermsOfService: React.FC = () => {
  return (
    <div className="legal-page">
      <div className="container">
        <h1 className="legal-page__title heading-1">Terms of Service</h1>
        <p className="legal-page__updated">Last updated: February 2026</p>

        <section className="legal-page__section">
          <h2 className="legal-page__heading heading-3">1. Acceptance of Terms</h2>
          <p>
            By accessing or using Furudio's website and services, you agree to be bound 
            by these Terms of Service. If you do not agree to these terms, please do not 
            use our services.
          </p>
        </section>

        <section className="legal-page__section">
          <h2 className="legal-page__heading heading-3">2. Description of Service</h2>
          <p>
            Furudio provides a strategy planning and implementation platform designed to 
            help organizations visualize dependencies, track progress, and align teams 
            around shared objectives.
          </p>
        </section>

        <section className="legal-page__section">
          <h2 className="legal-page__heading heading-3">3. User Responsibilities</h2>
          <p>You agree to:</p>
          <ul className="legal-page__list">
            <li>Provide accurate and complete information when registering</li>
            <li>Maintain the security of your account credentials</li>
            <li>Use the service in compliance with applicable laws and regulations</li>
            <li>Not attempt to access unauthorized areas of the service</li>
          </ul>
        </section>

        <section className="legal-page__section">
          <h2 className="legal-page__heading heading-3">4. Intellectual Property</h2>
          <p>
            All content, features, and functionality of Furudio, including but not limited 
            to text, graphics, logos, and software, are the exclusive property of Furudio 
            and are protected by intellectual property laws.
          </p>
        </section>

        <section className="legal-page__section">
          <h2 className="legal-page__heading heading-3">5. Pricing and Payment</h2>
          <p>
            Furudio is currently in development. Pricing details will be published on our 
            website prior to commercial availability. By joining our waitlist, you are not 
            committing to any purchase. Final pricing and payment terms will be communicated 
            before any subscription begins.
          </p>
        </section>

        <section className="legal-page__section">
          <h2 className="legal-page__heading heading-3">6. Limitation of Liability</h2>
          <p>
            Furudio shall not be liable for any indirect, incidental, special, consequential, 
            or punitive damages resulting from your use of or inability to use the service.
          </p>
        </section>

        <section className="legal-page__section">
          <h2 className="legal-page__heading heading-3">7. Termination</h2>
          <p>
            We reserve the right to suspend or terminate your access to the service at any 
            time for violation of these terms or for any other reason at our discretion.
          </p>
        </section>

        <section className="legal-page__section">
          <h2 className="legal-page__heading heading-3">8. Governing Law</h2>
          <p>
            These Terms of Service shall be governed by and construed in accordance with 
            the laws of Finland, without regard to its conflict of law provisions.
          </p>
        </section>

        <section className="legal-page__section">
          <h2 className="legal-page__heading heading-3">9. Contact Us</h2>
          <p>
            If you have any questions about these Terms of Service, please contact us at:{' '}
            <a href="mailto:info@furudio.com">info@furudio.com</a>
          </p>
        </section>
      </div>
    </div>
  );
};

export default TermsOfService;
